module.exports = "<div class=\"account-tile-wrapper clickable account-page\" data-url=\"<%- urlAddon %>\">\n    <div class=\"account-tile\">\n        <span class=\"icon\"><img src=\"<%- icon %>\"></span>\n        <span class=\"label\"><%- label %>\n        </span>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/account/accountIcon.html
// module id = 763
// module chunks = 7